if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(".js-results-container");
      this.btnSubmit = this.querySelector(".js-btn-submit");
      this.btnClearText = this.querySelector(".js-btn-clear-text");

      this.errorMessageContainer = this.querySelector(".js-message-error");
      this.errorMessageText = this.errorMessageContainer.querySelector("[data-text]");

      this.timeout = null;
      this.isOpen = false;

      this.drawer = this.closest(".js-drawer");

      this.drawerContent = document.querySelector(".drawer__content--search");
      this.suggestions = document.querySelector(".search-drawer__suggestions");

      this.bindEvents();
    }

    bindEvents() {
      this.input.addEventListener("input", (e) => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const value = this.input.value.trim();

          if (!value.length) {
            this.close();

            if (window.innerWidth < 990 && this.drawerContent) {
              this.drawerContent.style.height = "auto";
            }

            if (this.suggestions) {
              this.suggestions.style.display = "block";
            }

            return;
          }

          this.isOpen = true;
          this.getSearchResults(value);

          if (window.innerWidth <= 990 && this.drawerContent) {
            this.drawerContent.style.height = "100%";
          }

          if (this.suggestions) {
            this.suggestions.style.display = "none";
          }
        }, 300);
      });

      this.input.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") return;

        if (this.input.value) {
          this.close();
        } else if (this.drawer) {
          this.drawer.toggleDrawer?.();
        }
      });

      this.btnClearText.addEventListener("click", () => {
        this.close();

        if (this.drawerContent) {
          this.drawerContent.style.height = "auto";
        }

        if (this.suggestions) {
          this.suggestions.style.display = "block";
        }
      });
    }

    async getSearchResults(query) {
      try {
        const res = await fetch(
          `${Shopify.routes.root}search/suggest?q=${query}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) return;

        if (!res.ok) {
          throw new Error(res.status);
        }

        const html = await res.text();

        const doc = new DOMParser().parseFromString(html, "text/html");
        const results = doc.querySelector("#shopify-section-predictive-search");

        this.resultsContainer.innerHTML = results ? results.innerHTML : "";

        this.open();

        // ✅ CLEAN EVENT: notify cart drawer instead of calling methods
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            detail: { source: "predictive-search" }
          })
        );

      } catch (err) {
        this.errorMessageText.textContent = err.message;
        this.errorMessageContainer.classList.remove("hidden");
      }
    }

    open() {
      this.classList.add("is-open");
      this.resultsContainer.classList.remove("hidden");
      this.errorMessageContainer.classList.add("hidden");

      this.btnSubmit.setAttribute("tabindex", "-1");
      this.btnClearText.removeAttribute("disabled");
    }

    close() {
      this.isOpen = false;

      this.classList.remove("is-open");
      this.resultsContainer.classList.add("hidden");
      this.errorMessageContainer.classList.add("hidden");

      this.input.value = "";
      this.input.focus();

      this.btnSubmit.removeAttribute("tabindex");
      this.btnClearText.setAttribute("disabled", true);
    }
  }

  customElements.define("predictive-search", PredictiveSearch);
}